import React from 'react'

export default function Heading() {
    return (
        <div className='flex justify-center items-center pt-20'>
            <h1 className='text-[#DD2F29] text-[30px] md:text-[40px] leading-[52px] font-bold'>Services <span className='text-[#2E3D62]'>We Provide  </span></h1>
        </div>
    )
}
